<template>
  <div>
    <div v-if="showLoading" class="loading-div">
      <van-loading
        type="spinner"
        size="150px"
        :color="$enum.CONSTANT.APP_THEME_COLOR"
        text-size="50px"
        :text-color="$enum.CONSTANT.APP_THEME_COLOR"
        vertical
        >正在查询支付状态</van-loading
      >
    </div>
    <!-- <div v-else> -->
    <!-- <van-button @click="handleClickPayed">已支付</van-button> -->
    <Dialog
      v-model="showDialog"
      title="支付状态"
      show-cancel-button
      @confirm="handleClickPayed"
      confirm-button-text="是"
      cancel-button-text="否"
      @cancel="handleCancelPayed"
    >
      <div class="info-div">
        <div class="info-img-div">确认是否已完成支付</div>
        <br>
      </div>
    </Dialog>
    <!-- </div> -->
  </div>
</template>

<script>
import { Loading, Icon, Dialog } from "vant";
import { getOrderStatus, getYuedongAccount } from "@/request/api";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "payBack",
  computed: {
    ...mapGetters(["sOrderId"]),
  },
  components: {
    [Loading.name]: Loading,
    [Icon.name]: Icon,
    Dialog: Dialog.Component,
  },
  created() {},
  mounted() {
    this.init();
    document.addEventListener("visibilitychange", this.init);
  },
  data() {
    return {
      showLoading: false,
      orderStatusTimer: "",
      count: 0,
      showPayResult: false,
      showDialog: false,
      // icon: "passed",
      // msg: "支付成功",
      // color: "#58bd6a",
      // dialogMsg: "已完成支付?",
    };
  },
  beforeDestroy() {
    document.removeEventListener("visibilitychange", this.init, true);
    this.stopOrderTimer();
    this.count = 0;
  },
  methods: {
    ...mapMutations(["sSetUserInfo"]),
    init() {
      let isHidden = document.hidden;
      this.showLoading = true;
      if (isHidden) {
        this.stopOrderTimer();
        this.count = 0;
      } else {
        this.orderStatusTimer = setInterval(this.isPay, 1000);
      }
    },
    //通过token查询用户信息
    getUserInfoForToken() {
      getYuedongAccount({}).then((res) => {
        this.sSetUserInfo(res);
      });
    },
    handleClickPayed() {
      this.stopOrderTimer();
      if (!this.showPayResult) {
        getOrderStatus({ 
          orderId: this.sOrderId 
        }).then((res)=>{
          if(res===true){
            this.toOrder();
          }else{
            this.toHistoryOrder();
          }
        })
      } else {
        this.toOrder();
      }
    },
    handleCancelPayed() {
      this.stopOrderTimer();
      this.toHistoryOrder();
    },
    isPay() {
      if (this.count > 5) {
        this.showLoading = false;
        this.showPayResult = false;
        this.showDialog = true;
        // this.dialogMsg=''
        this.stopOrderTimer();
        // this.toHistoryOrder()
      }
      this.count = this.count + 1;
      getOrderStatus({
        orderId: this.sOrderId,
      }).then((res) => {
        if (res === true) {
          this.showLoading = false;
          // this.showPayResult = true;
          // this.showDialog = true;
          // this.icon = "passed";
          // this.color = "#58bd6a";
          // this.msg = "支付成功";
          this.stopOrderTimer();
          this.toOrder();
        }
      });
    },

    toOrder() {
      //更新用户余额
      this.getUserInfoForToken();

      this.$router.replace({
        name: "orderDetail",
      });
    },
    toHistoryOrder() {
      this.$router.replace({
        name: "historyOrder",
      });
    },
    stopOrderTimer() {
      clearInterval(this.orderStatusTimer);
    },
  },
};
</script>

<style scoped>
.loading-div {
  margin-top: 160px;
}

.info-div {
  margin-top: 20px;
}

.info-icon-div {
  font-size: 100px;
  text-align: center;
}

.info-img-div {
  font-size: 20px;
  margin: 0rpx auto;
  text-align: center;
}
</style>
